/* Polorizer redesign: converts the old theme cyan/turquoise and bright-green accents
   (hard-coded inside many older sections, app blocks and the cart drawer)
   to the new theme colours. Strong cyan -> deep green, pale cyan tints -> sand.
   Only colours change; layout and behaviour are untouched. */
(function () {
  'use strict';
  var GREEN = [45, 75, 67], DARK = [31, 56, 50], SAND = [243, 238, 230];

  function toHex(c) { return '#' + c.map(function (v) { return ('0' + v.toString(16)).slice(-2); }).join(''); }

  function hsl(r, g, b) {
    r /= 255; g /= 255; b /= 255;
    var mx = Math.max(r, g, b), mn = Math.min(r, g, b), d = mx - mn, l = (mx + mn) / 2, h = 0, s = 0;
    if (d > 0.0001) {
      s = d / (1 - Math.abs(2 * l - 1));
      if (mx === r) h = ((g - b) / d) % 6; else if (mx === g) h = (b - r) / d + 2; else h = (r - g) / d + 4;
      h *= 60; if (h < 0) h += 360;
    }
    return [h, s, l];
  }

  /* Returns replacement rgb array, or null if the colour is not an old cyan accent */
  function mapRgb(r, g, b) {
    var x = hsl(r, g, b), h = x[0], s = x[1], l = x[2];
    if (h < 90 || h > 200 || s < 0.4) return null;
    if (l >= 0.78) return SAND;
    if (l < 0.3) return DARK;
    return GREEN;
  }

  var RE = /#([0-9a-f]{6}|[0-9a-f]{3})\b|rgba?\(\s*(\d{1,3})[\s,]+(\d{1,3})[\s,]+(\d{1,3})(?:[\s,\/]+([\d.]+%?))?\s*\)/gi;

  function mapValue(v) {
    if (!v) return v;
    return v.replace(RE, function (m, hex, r, g, b, a) {
      var c;
      if (hex) {
        if (hex.length === 3) hex = hex.split('').map(function (ch) { return ch + ch; }).join('');
        c = [parseInt(hex.slice(0, 2), 16), parseInt(hex.slice(2, 4), 16), parseInt(hex.slice(4, 6), 16)];
      } else {
        c = [+r, +g, +b];
      }
      var t = mapRgb(c[0], c[1], c[2]);
      if (!t) return m;
      if (a !== undefined && a !== '1') return 'rgba(' + t.join(', ') + ', ' + a + ')';
      return toHex(t);
    });
  }

  function isDark(v) {
    var m = /rgba?\(\s*(\d+)[\s,]+(\d+)[\s,]+(\d+)/.exec(v);
    if (!m) { var hx = /#([0-9a-f]{6})/i.exec(v); if (!hx) return false; m = [0, parseInt(hx[1].slice(0, 2), 16), parseInt(hx[1].slice(2, 4), 16), parseInt(hx[1].slice(4, 6), 16)]; }
    return hsl(+m[1], +m[2], +m[3])[2] < 0.35;
  }

  /* Recolour one CSSStyleDeclaration in place */
  function fixStyle(st) {
    if (!st || !st.length) return;
    var bgTurnedGreen = false;
    for (var i = 0; i < st.length; i++) {
      var prop = st[i];
      if (prop.indexOf('--') !== 0 && !/color|background|border|outline|shadow|fill|stroke|caret|decoration|column-rule/.test(prop)) continue;
      var val = st.getPropertyValue(prop);
      if (!val || !/#|rgb/i.test(val)) continue;
      var nv = mapValue(val);
      if (nv !== val) {
        st.setProperty(prop, nv, st.getPropertyPriority(prop));
        if (/^background/.test(prop) && /#2d4b43|#1f3832|45, 75, 67|31, 56, 50/i.test(nv)) bgTurnedGreen = true;
      }
    }
    /* Dark text on a button that used to be cyan becomes white so it stays readable */
    if (bgTurnedGreen) {
      var col = st.getPropertyValue('color');
      if (col && isDark(col)) st.setProperty('color', '#ffffff', st.getPropertyPriority('color'));
    }
  }

  function fixRules(rules) {
    if (!rules) return;
    for (var i = 0; i < rules.length; i++) {
      var r = rules[i];
      if (r.style) fixStyle(r.style);
      if (r.cssRules) fixRules(r.cssRules);
    }
  }

  var done = typeof WeakSet !== 'undefined' ? new WeakSet() : null;
  function fixSheet(sheet) {
    if (!sheet) return;
    var href = sheet.href || '';
    if (href.indexOf('polorizer-redesign') !== -1) return;
    var rules;
    try { rules = sheet.cssRules; } catch (e) { return; } /* cross-origin sheet */
    if (done) { if (done.has(sheet)) return; done.add(sheet); }
    fixRules(rules);
  }

  function fixAllSheets() {
    for (var i = 0; i < document.styleSheets.length; i++) fixSheet(document.styleSheets[i]);
  }

  var SVG_ATTRS = ['fill', 'stroke', 'stop-color', 'color'];
  function fixElement(el) {
    if (!el || el.nodeType !== 1) return;
    if (el.hasAttribute('style')) fixStyle(el.style);
    if (el instanceof SVGElement) {
      for (var i = 0; i < SVG_ATTRS.length; i++) {
        var a = el.getAttribute(SVG_ATTRS[i]);
        if (a && /#|rgb/i.test(a)) { var n = mapValue(a); if (n !== a) el.setAttribute(SVG_ATTRS[i], n); }
      }
    }
  }

  function fixTree(root) {
    if (!root || !root.querySelectorAll) return;
    fixElement(root);
    var els = root.querySelectorAll('[style], svg [fill], svg [stroke], svg [stop-color]');
    for (var i = 0; i < els.length; i++) fixElement(els[i]);
  }

  function run() {
    fixAllSheets();
    if (document.body) fixTree(document.body);
  }

  run();
  document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('load', run);

  /* Stylesheets that finish loading later (the theme loads some asynchronously) */
  document.addEventListener('load', function (e) {
    if (e.target && e.target.tagName === 'LINK' && e.target.sheet) fixSheet(e.target.sheet);
  }, true);

  /* Content injected later: cart drawer, quick view, app widgets */
  if ('MutationObserver' in window) {
    var pending = false;
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i];
        if (m.type === 'attributes') { fixElement(m.target); continue; }
        if (m.target && m.target.tagName === 'STYLE') { pending = true; continue; }
        for (var j = 0; j < m.addedNodes.length; j++) {
          var n = m.addedNodes[j];
          if (n.nodeType !== 1) continue;
          if (n.tagName === 'STYLE' || n.tagName === 'LINK') { pending = true; }
          else { fixTree(n); if (n.querySelector && n.querySelector('style')) pending = true; }
        }
      }
      if (pending) {
        pending = false;
        /* recolour new stylesheets before the next paint, so old colours never flash */
        (window.requestAnimationFrame || setTimeout)(fixAllSheets);
      }
    });
    mo.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'fill', 'stroke'] });
  }
})();
